import BotConditionCard from "./BotConditionCard";
import React from "react";
import {Box, Button, IconButton} from "@mui/material";
import {useWatch} from "react-hook-form";
import ReactHookFormCheckbox from "../../input/ReactHookFormCheckbox";
import ReactHookFormRadio from "../../input/ReactHookFormRadio";
import BrowserMultiSelect from "../../campaigns/conditions/BrowserMultiSelect";
import {Add, Delete} from "@mui/icons-material";

function BotConditionBrowser(props) {
    const {control, setValue, getValues} = props;

    // Watch the global rules object in real-time
    const rules = useWatch({control, name: "rules"}) || {};
    const browserData = rules?.browser;
    const hasBrowserCondition = !!browserData;

    const radioConditions = [
        {label: "Is", value: "is", color: "primary"},
        {label: "Is not", value: "isNot", color: "error"},
    ];

    // REMOVE: Safe JS delete approach
    const removeCondition = () => {
        const currentRules = {...getValues("rules")};
        delete currentRules.browser;
        setValue("rules", currentRules);
    };

    // ADD: Initialize flat browser object
    const addCondition = () => {
        setValue("rules.browser", {
            condition: "is",
            includeEmptyValue: false,
            values: []
        });
    };

    const renderAddCondition = () => {
        if (!hasBrowserCondition) {
            return (
                <Box display="flex" flexDirection="row" alignItems="center" gap={2}>
                    <Box flexGrow={1} sx={{minWidth: 0, fontSize: 14, fontWeight: 600}}>
                        <span>Browser</span>
                    </Box>
                    <Box>
                        <Button
                            aria-label="condition"
                            color="primary"
                            title="Add condition"
                            startIcon={<Add/>}
                            onClick={addCondition}
                            sx={{textTransform: "none", py: 0.25, px: 1}}
                        >
                            Add condition
                        </Button>
                    </Box>
                </Box>
            );
        }
    };

    const renderConditionBox = () => {
        if (hasBrowserCondition) {
            return (
                <>
                    <Box display="flex" flexDirection="row" alignItems="center" gap={2}>
                        <Box flexGrow={1} sx={{minWidth: 0, fontSize: 14, fontWeight: 600}}>
                            Browser
                        </Box>
                        <Box>
                            <IconButton
                                aria-label="remove"
                                color="default"
                                title="Remove"
                                size="small"
                                onClick={removeCondition}
                                sx={{color: 'error.dark'}}
                            >
                                <Delete fontSize="small"/>
                            </IconButton>
                        </Box>
                    </Box>
                    <Box>
                        <ReactHookFormRadio
                            control={control}
                            options={radioConditions}
                            name="rules.browser.condition"
                            label="conditions"
                        />
                    </Box>
                    <Box>
                        <ReactHookFormCheckbox
                            control={control}
                            label="Include empty value"
                            labelPlacement="end"
                            name="rules.browser.includeEmptyValue"
                        />
                    </Box>
                    <Box sx={{mt: 1}}>
                        <BrowserMultiSelect
                            control={control}
                            inputName="rules.browser.values"
                            inputLabel="Browser"
                        />
                    </Box>
                </>
            );
        }
    };

    return (
        <BotConditionCard>
            {renderAddCondition()}
            {renderConditionBox()}
        </BotConditionCard>
    );
}

export default BotConditionBrowser;
